import { GridActionsCellItem } from '@mui/x-data-grid';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import GoalModal from '../Goals/GoalModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { GoalActionProps } from './GoalAction';
import { useGoalAndOperationalPlansForm } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider';
import { useWatch } from 'react-hook-form';

const GoalEditButton = ({ rowId, planIndex }: GoalActionProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues } = useGoalAndOperationalPlansForm();
  const completedSection = useWatch({
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const data =
    getValues(`companyValueIncreasePlans.valueUpPlans.${planIndex}.goals`) ||
    [];
  const editData = data[Number(rowId)];

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlinedIcon style={{ fontSize: '16px' }} />}
        label="Edit"
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {opened && (
        <GoalModal
          actionType="edit"
          open={opened}
          onClose={close}
          planIndex={planIndex}
          rowId={Number(rowId)}
          editData={editData}
        />
      )}
    </>
  );
};
export default GoalEditButton;
